// 不支持消息
import React, {memo} from 'react'
import styled from 'styled-components'

const CardMsg = styled.span`
  display: inline-block;
  background: #ffffff;
  height: 48px;
  border: 1px solid #D9D9D9;
  padding: 15px 16px 0 16px;
  font-size: 12px;
  color: #BFBFBF;
  margin-top: 8px;
`

const RenderCardMsg = memo((props) => {
  const {value} = props
  let message = value.messageContent ? JSON.parse(value.messageContent) : {}
  return(
    <CardMsg>
      {
        message.userName ? `${message.userName}的名片, 暂不支持查看` : '名片，暂不支持查看'
      }
    </CardMsg>
  )
})

export default RenderCardMsg
